module.exports = __webpack_public_path__ + "cd665a6a8492f782cba916ebee277fca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/DarkHorseRowingBackdrop.png
// module id = 1223
// module chunks = 0